(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nisaa-avis-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nisaa-ugc-videos')) {
    customElements.define('nisaa-ugc-videos', class extends HTMLElement {

      connectedCallback() {
        this.abort = new AbortController();

        const options = {
          signal: this.abort.signal
        };

        this.track = this.querySelector('.nisaa-ugc__track');
        this.videos = Array.from(this.querySelectorAll('video'));
        this.visible = new Set();
        this.manuallyPaused = new Set();

        this.motion = window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        );

        this.prev = this.querySelector('.nisaa-ugc__arrow--prev');
        this.next = this.querySelector('.nisaa-ugc__arrow--next');

        this.videos.forEach(video => {
          video.muted = true;
          video.defaultMuted = true;
          video.controls = false;

          const card = video.closest('.nisaa-ugc__card');

          card.querySelector('.nisaa-ugc__sound-button')
            .addEventListener('click', () => {

              if (video.paused || video.muted) {
                document.dispatchEvent(
                  new CustomEvent('nisaa:ugc:unmute', {
                    detail: { video }
                  })
                );

                video.muted = false;
                this.manuallyPaused.delete(video);
                this.play(video);
              } else {
                video.muted = true;
              }

              this.updateVideo(video);

            }, options);

          card.querySelector('.nisaa-ugc__pause')
            .addEventListener('click', () => {

              if (video.paused) {
                this.manuallyPaused.delete(video);
                this.play(video);
              } else {
                this.manuallyPaused.add(video);
                this.stop(video);
              }

            }, options);

          ['play', 'pause', 'volumechange', 'error']
            .forEach(name => {
              video.addEventListener(
                name,
                () => this.updateVideo(video),
                options
              );
            });

          this.updateVideo(video);
        });

        document.addEventListener(
          'nisaa:ugc:unmute',
          event => {
            this.videos.forEach(video => {
              if (video !== event.detail.video) {
                video.muted = true;
                this.updateVideo(video);
              }
            });
          },
          options
        );

        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            const video = entry.target;

            if (
              entry.isIntersecting &&
              entry.intersectionRatio >= .25
            ) {
              this.visible.add(video);
              this.autoplay(video);
            } else {
              this.visible.delete(video);
              this.stop(video);
            }
          });
        }, {
          threshold: [0, .25]
        });

        this.videos.forEach(video => {
          this.observer.observe(video);
        });

        document.addEventListener(
          'visibilitychange',
          () => {
            if (document.hidden) {
              this.videos.forEach(video => this.stop(video));
            } else {
              this.visible.forEach(video => this.autoplay(video));
            }
          },
          options
        );

        this.motion.addEventListener(
          'change',
          () => {
            this.videos.forEach(video => this.stop(video));
            this.visible.forEach(video => this.autoplay(video));
          },
          options
        );

        this.prev.addEventListener(
          'click',
          () => this.move(-1),
          options
        );

        this.next.addEventListener(
          'click',
          () => this.move(1),
          options
        );

        this.track.addEventListener(
          'scroll',
          () => this.updateArrows(),
          {
            ...options,
            passive: true
          }
        );

        this.track.addEventListener('keydown', event => {
          if (
            event.target !== this.track ||
            !['ArrowLeft', 'ArrowRight'].includes(event.key)
          ) {
            return;
          }

          event.preventDefault();

          this.move(
            event.key === 'ArrowLeft' ? -1 : 1
          );
        }, options);

        this.addEventListener('shopify:block:select', event => {
          const card = this.querySelector(
            `[data-block-id="${event.detail.blockId}"]`
          );

          if (card) {
            this.track.scrollTo({
              left: card.offsetLeft,
              behavior: 'instant'
            });
          }
        }, options);

        this.resizeObserver = new ResizeObserver(() => {
          this.updateArrows();
        });

        this.resizeObserver.observe(this.track);

        this.classList.add('is-ready');
        this.updateArrows();
      }

      autoplay(video) {
        if (
          this.dataset.autoplay !== 'true' ||
          this.motion.matches ||
          document.hidden ||
          this.manuallyPaused.has(video)
        ) {
          return;
        }

        this.play(video);
      }

      play(video) {
        const attempt = video.play();

        if (attempt) {
          attempt.catch(error => {
            if (error.name !== 'AbortError') {
              video.muted = true;
              this.updateVideo(video);
            }
          });
        }
      }

      stop(video) {
        video.muted = true;
        video.pause();
        this.updateVideo(video);
      }

      updateVideo(video) {
        const card = video.closest('.nisaa-ugc__card');

        const sound = card.querySelector(
          '.nisaa-ugc__sound-button'
        );

        const pause = card.querySelector(
          '.nisaa-ugc__pause'
        );

        card.classList.toggle(
          'is-unmuted',
          !video.muted
        );

        card.classList.toggle(
          'is-paused',
          video.paused
        );

        sound.setAttribute(
          'aria-pressed',
          String(!video.muted)
        );

        const action = video.paused
          ? 'Lire avec le son'
          : video.muted
            ? 'Activer le son'
            : 'Couper le son';

        sound.setAttribute(
          'aria-label',
          `${action} — ${sound.dataset.label}`
        );

        pause.setAttribute(
          'aria-label',
          `${video.paused ? 'Reprendre la vidéo' : 'Mettre en pause'} — ${pause.dataset.label}`
        );
      }

      move(direction) {
        const card = this.track.querySelector(
          '.nisaa-ugc__card'
        );

        if (!card) return;

        const step =
          card.getBoundingClientRect().width +
          parseFloat(
            getComputedStyle(this.track).gap || 0
          );

        this.track.scrollBy({
          left: step * direction,
          behavior: this.motion.matches
            ? 'instant'
            : 'smooth'
        });
      }

      updateArrows() {
        const maximum =
          this.track.scrollWidth -
          this.track.clientWidth;

        this.prev.hidden = maximum <= 2;
        this.next.hidden = maximum <= 2;

        this.prev.disabled =
          this.track.scrollLeft <= 2;

        this.next.disabled =
          this.track.scrollLeft >= maximum - 2;
      }

      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();

        this.videos?.forEach(video => {
          video.muted = true;
          video.pause();
        });
      }

    });
  }

  } catch(e) { console.error(e); }
})();
})();
